export default __webpack_public_path__ + "static/media/ic_vacation_48px.adc9c41d.svg";